"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var socket_io_client_1 = __importDefault(require("socket.io-client"));
var error_1 = __importDefault(require("../utils/error"));
var callback_manager_1 = __importDefault(require("./callback_manager"));
var ClientV0 = /** @class */ (function () {
    function ClientV0(server, config) {
        if (config === void 0) { config = {}; }
        this.user_list = [];
        this.server = server;
        this.callbacks = new callback_manager_1.default();
        this.config = config;
    }
    ClientV0.prototype._connect = function (type, data, cb) {
        if (data === void 0) { data = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var connect_error_cb = function () {
                            _this.disconnect();
                            reject(new error_1.default('no_connection', 'No connection to server'));
                        };
                        _this.socket = socket_io_client_1.default(_this.server);
                        _this.socket.on('user-list', _this._onUserList.bind(_this));
                        _this.socket.on('custom', _this._onCustom.bind(_this));
                        _this.socket.on('server-close', _this._onServerClose.bind(_this));
                        //this.socket.on('error', this._onError.bind(this));
                        _this.socket.on('connect_error', connect_error_cb);
                        _this.socket.emit(type, data, function (res) {
                            if (res.error) {
                                var msg = void 0;
                                switch (res.error) {
                                    case 'bad_game':
                                        msg = 'Trying to connect to bad game';
                                        break;
                                    case 'full_game':
                                        msg = 'The game is full';
                                        break;
                                    default:
                                        msg = 'Unexpected error';
                                }
                                _this.disconnect();
                                reject(new error_1.default(res.error, msg));
                                return;
                            } // if data.error
                            cb(res);
                            resolve();
                        }); // Socket emit create/join
                    })];
            });
        });
    };
    ClientV0.prototype.create = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this._connect('create', __assign({}, this.config), function (res) {
                        _this.game_id = res.game_id;
                        _this.user_id = res.user_id;
                        _this.user_list = res.user_list;
                    })];
            });
        });
    };
    ClientV0.prototype.join = function (game_id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this._connect('join', __assign({ game_id: game_id }, this.config), function (res) {
                        _this.game_id = res.game_id;
                        _this.user_id = res.user_id;
                        _this.user_list = res.user_list;
                    })];
            });
        });
    };
    Object.defineProperty(ClientV0.prototype, "user_idx", {
        get: function () {
            for (var i = 0; i < this.user_list.length; i++) {
                if (this.user_list[i] === this.user_id)
                    return i;
            }
            return -1;
        },
        enumerable: true,
        configurable: true
    });
    ClientV0.prototype.on = function (channel, cb) {
        return this.callbacks.add(channel, cb);
    };
    ClientV0.prototype.off = function (channel, cb) {
        if (cb === void 0) { cb = null; }
        this.callbacks.rm(channel, cb);
    };
    ClientV0.prototype.emit = function (channel) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this._emitCustom('other', { channel: channel, data: __spreadArrays(args) });
    };
    ClientV0.prototype.disconnect = function () {
        this.callbacks.rmAll();
        this.socket.disconnect(true);
    };
    ClientV0.prototype._onUserList = function (data) {
        this.user_list = data.user_list;
    };
    ClientV0.prototype._onCustom = function (msg) {
        var user_id = msg.user_id, type = msg.type, data = msg.data;
        switch (type) {
            case 'other':
                return this._onOther(user_id, data);
        }
    };
    ClientV0.prototype._emitCustom = function (type, data) {
        this.socket.emit('custom', {
            game_id: this.game_id,
            user_id: this.user_id,
            type: type,
            data: data
        });
    };
    ClientV0.prototype._onOther = function (user_id, other) {
        var _a;
        var channel = other.channel, data = other.data;
        (_a = this.callbacks).run.apply(_a, __spreadArrays([channel], data));
    };
    ClientV0.prototype._onServerClose = function () {
        this.disconnect();
    };
    return ClientV0;
}());
exports.default = ClientV0;
